import React, { useState, useEffect, useRef } from "react";
import Select from './select.js';
import html2canvas from 'html2canvas';
import Preview from './preview.js';

const formattypes = [
    { id: 'text', name: "Text" },
    { id: 'image', name: "Image" },
]

const Send = ({ templates = [], contact = {}, listing = {}, state, setState }) => {
    const [format, setFormat] = useState("text");
    const [templateid, setTemplateid] = useState("");
    const [templatecontent, setTemplatecontent] = useState('');
    const [templatetext, setTemplatetext] = useState('');

    const [result, setResult] = useState('');
    const printRef = useRef();

    useEffect(() => {
        if (!templates?.length) setTemplatecontent('No templates found, please adjust in the settings.')
        if (templates.length == 1) setTemplateid(templates[0]?.id)
        if (templates.length > 1) {
            const keywords = ['whatsapp'];
            const targetTemplate = templates.find(t => keywords.some(k => t.name?.toLowerCase().includes(k))) || templates[0];
            if (targetTemplate) {
                setTemplateid(targetTemplate.id);
            }
            else {
                setTemplateid(templates[0]?.id)
            }
        }
    }, [templates]);

    useEffect(() => {
        if (!templates || templates.length === 0) {
        }

        const currentTemplate = templates.find(template => template.id === templateid) || templates[0];

        let content = listing.descriptionunfiltered
            .filter(item => item.data && item.data.replace(/\r/g, '').trim() !== '')
            .map(item => {
                const cleanData = item.data.replace(/\r/g, '').trim();

                const className = item.rtl
                    ? 'listings_textdirectionalityright listings_textalignright'
                    : 'listings_textdirectionalityleft listings_textalignleft';

                const direction = item.rtl ? 'rtl' : 'ltr';

                return `<div class="${className}" dir="${direction}">${cleanData}</div>`;
            })
            .join('\n');

        if (format == 'text') {
            if (listing.metatags && listing.metatags.canonical) {
                const canonicalUrl = listing.metatags.canonical;
                content += `\n<div class="listings_textdirectionalityleft listings_textalignleft" style="margin-top: 12px;"><a href="${canonicalUrl}" target="_blank">${canonicalUrl}</a></div>`;
            }
        }

        const tempElement = document.createElement('div');
        tempElement.innerHTML = templatecontent;
        const plainText = tempElement.innerText || tempElement.textContent || '';

        setTemplatetext(plainText);
        setTemplatecontent(content);
    }, [format, templates, templateid]);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    };

    const handleShare = async () => {
        const title = 'Print';

        if (format == 'text') {
            if (navigator.share) {
                navigator.share({
                    title: title,
                    text: templatetext,
                    url: listing.metatags.canonical
                }).then(() => {
                }).catch((error) => {
                    alert('error')
                }).finally(() => {
                });

            } else {
                alert('Web Share API is not supported in your browser.');
            }
        }
        if (format == 'image') {
            try {
                const canvas = await html2canvas(printRef.current, {
                    scale: 2,
                    backgroundColor: '#ffffff',
                    useCORS: true
                });

                const blob = await new Promise(resolve => {
                    canvas.toBlob(resolve, 'image/png');
                });

                const file = new File(
                    [blob],
                    'print.png',
                    { type: 'image/png' }
                );

                await navigator.share({
                    title: title,
                    files: [file]
                });

            } catch (error) {
                console.log('Error:', error);
            }
        }
    };

    const handleCopy = async () => {
        try {
            if (format === 'text') {
                await navigator.clipboard.writeText(templatetext);
                setResult('Copied to clipboard');
                return;
            }

            if (format === 'image') {
                const canvas = await html2canvas(printRef.current, {
                    scale: 2,
                    backgroundColor: '#ffffff',
                    useCORS: true
                });

                const blob = await new Promise(resolve => {
                    canvas.toBlob(resolve, 'image/png');
                });

                if (!blob) {
                    setResult('Failed to create image');
                    return;
                }

                await navigator.clipboard.write([
                    new ClipboardItem({
                        'image/png': blob
                    })
                ]);

                setResult('Image copied to clipboard');
            }
        } catch (error) {
            console.log('Copy error:', error);
            setResult('Failed to copy');
        }
    };

    return (
        <div className="modal_body">
            <div className='modal_row'>
                <div className='modal_section'>
                    <Select data={formattypes} itemid={format} setItemid={setFormat} label='Format' />
                </div>
            </div>

            <div className="modal_printable">
                <div className='modal_row'>
                    <div className='modal_rowsection'>
                        <Preview content={templatecontent} images={listing.images} printRef={printRef} />
                    </div>
                </div>
            </div >

            <div className='modal_actions'>
                {result && <div className='modal_result'>{result}</div>}
                <div className='modal_buttons'>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleShare}>Share</button>
                    </div>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleCopy}>Copy</button>
                    </div>
                    <div className="modal_buttoncontainer">
                        <button className="modal_button" onClick={handleCloseModal}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Send;